export const FormInputTypeOptions = [
  "string",
  "number",
  "float",
  "money",
  "percentage",
  "email",
  "phone",
  "select",
  "postalCode",
  "country",
  "date",
  "monthNumber",
  "yearNumber",
  "boolean",
  "iban",
  "idNumber",
  "permitNumber",
  "kvkNumber",
  "bsn",
  "hdnReceivercode",
  "nwwiNumber",
  "kifidNumber",
  "afmNumber",
  "bagNumber",
  "multiSelect",
  "check",
  "radio",
  "checkboxes",
  "hidden",
] as const;
export type FormInputType = (typeof FormInputTypeOptions)[number];

export const FormInputPopupTypeOptions: Partial<FormInputType[]> = [
  "select",
  "multiSelect",
  "date",
  "monthNumber",
  "yearNumber",
  "country",
];
